export interface ArbitroMovilidadJSON {
  arbm_id: string | null;
  arbm_descripcion: string;
  arbm_activo: boolean;
}

export class ArbitroMovilidad {
  protected constructor(private id: string | null, private descripcion: string, private activo: boolean) {}

  static createFrom(id: string | null, descripcion: string, activo: boolean) {
    return new this(id, descripcion, activo);
  }

  isIdentifiedBy(anId: string): boolean {
    return this.id === anId;
  }

  isIdentifiedAs(aEntity: ArbitroMovilidad) {
    if (this.id) {
      return aEntity.isIdentifiedBy(this.id);
    } else {
      return false;
    }
  }

  static fromJSON(entity: ArbitroMovilidadJSON) {
    return ArbitroMovilidad.createFrom(entity.arbm_id, entity.arbm_descripcion, entity.arbm_activo);
  }

  toJSON(): ArbitroMovilidadJSON {
    return {
      arbm_id: this.getId(),
      arbm_descripcion: this.getDescripcion(),
      arbm_activo: this.getActivo(),
    };
  }

  getId(): string | null {
    return this.id;
  }

  getDescripcion(): string {
    return this.descripcion;
  }

  getActivo(): any {
    return this.activo;
  }

  setId(value: string | null): void {
    this.id = value;
  }

  setDescripcion(value: string): void {
    this.descripcion = value;
  }

  setActivo(value: any): void {
    this.activo = value;
  }
}
